import React, { Component } from "react";
import PropTypes from "prop-types";
import { CardHeader, IconButton, Menu, MenuItem } from "material-ui";
import UserAvatar from "./UserAvatar";
import { Link } from "react-router-dom";
import { defaultName } from "../utils/userUtils";
import { MoreVert } from "material-ui-icons";
import TimeFromNow from "./TimeFromNow";
import { withStylesAndTranslation } from "../utils/container";
import { CopyToClipboard } from "react-copy-to-clipboard";

const styleSheet = theme => {
    return {
        card: {
            maxWidth: 400
        },
        avatarLink: {
            textDecoration: "none"
        },
        link: {
            ...theme.typography.body2,
            fontWeight: "bold",
            textDecoration: "none"
        },
        headerAction: {
            display: "flex",
            alignItems: "center"
        },
        cardHeaderContent: {
            minWidth: 0,
            overflow: "hidden"
        },
        cardTitleContent: {
            textOverflow: "ellipsis",
            overflow: "hidden"
        }
    };
};

const lookupLanguageText = ({ language }) => {
    return "languages.codes." + language;
};

const Languages = ({ t, languages }) => {
    const learningLanguages = languages.filter(l => l.isLearning);
    const masteredLanguages = languages.filter(l => !l.isLearning);

    return (
        <div>
            {masteredLanguages
                .map(lookupLanguageText)
                .map(t)
                .join(t("postHeader.languageSeparator"))}
            &nbsp;&nbsp;&gt;&nbsp;&nbsp;
            {learningLanguages
                .map(lookupLanguageText)
                .map(t)
                .join(t("postHeader.languageSeparator"))}
        </div>
    );
};

Languages.propTypes = {
    languages: PropTypes.any,
    t: PropTypes.func.isRequired
};

class PostHeader extends Component {
    state = {
        anchorEl: null,
        open: false
    };

    handleMenuItemClick = action => {
        return () => {
            this.props.onMenuItemClick(action);
            this.setState({ open: false });
        };
    };

    handleClick = event => {
        this.setState({ open: true, anchorEl: event.currentTarget });
    };

    handleRequestClose = () => {
        this.setState({ open: false });
    };

    renderAction() {
        const { classes, date, menuItemConfig } = this.props;
        return (
            <div className={classes.headerAction}>
                <TimeFromNow date={date} />
                <IconButton onClick={this.handleClick}>
                    <MoreVert />
                </IconButton>
                <Menu
                    anchorEl={this.state.anchorEl}
                    open={this.state.open}
                    onClose={this.handleRequestClose}>
                    {menuItemConfig.map(this.renderMenuItem)}
                </Menu>
            </div>
        );
    }

    renderMenuItem = config => {
        const { t, postId, correctionId } = this.props;

        const menuItem = (
            <MenuItem
                key={config.action}
                onClick={this.handleMenuItemClick(config.action)}>
                {t(config.text)}
            </MenuItem>
        );
        if (config.action === "copyLink") {
            const { protocol, hostname, port } = window.location;
            let url = `${protocol}//${hostname}${port
                ? ":" + port
                : ""}/posts/${postId}`;
            if (correctionId) {
                url += "#correction=" + correctionId;
            }
            return (
                <CopyToClipboard key={config.action} text={url}>
                    {menuItem}
                </CopyToClipboard>
            );
        }

        return menuItem;
    };

    render() {
        const { t, user, classes } = this.props;
        const { id, displayName, avatarURL, languages } = user;

        return (
            <CardHeader
                action={this.renderAction()}
                classes={{
                    content: classes.cardHeaderContent,
                    title: classes.cardTitleContent
                }}
                avatar={
                    <Link className={classes.avatarLink} to={`/profile/${id}`}>
                        <UserAvatar
                            avatarURL={avatarURL}
                            displayName={defaultName(displayName)}
                        />
                    </Link>
                }
                title={
                    <Link className={classes.link} to={`/profile/${id}`}>
                        {defaultName(displayName)}
                    </Link>
                }
                subheader={<Languages t={t} languages={languages} />}
            />
        );
    }
}

PostHeader.propTypes = {
    user: PropTypes.object,
    classes: PropTypes.object,
    date: PropTypes.object,
    postId: PropTypes.string.isRequired,
    correctionId: PropTypes.string,
    menuItemConfig: PropTypes.array,
    onMenuItemClick: PropTypes.func,
    t: PropTypes.func.isRequired
};

PostHeader.defaultProps = {
    menuItemConfig: Object.freeze([]),
    onMenuItemClick: () => {}
};

export default withStylesAndTranslation(PostHeader, styleSheet);



// WEBPACK FOOTER //
// ./src/components/PostHeader.jsx